import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap';
import CustomIconButton from '../custom-icon-button/CustomIconButton';
import { localStorageItem } from '../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { columns } from './Columns';
import { getListPedingPatient } from '../../utils/ServicesUtils';
import { OctTable } from '@oceantech/oceantech-ui';
import { CODE, PENDING_STATUS } from '../../utils/Constant';

const MAX_LENGTH_LIST_PATIENT = 5;

type Props = {}

const PendingScreen = (props: Props) => {
    const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);
    const phongSelected = localStorageItem.get(KEY_LOCALSTORAGE.ROOM_FOR_PENDING_SCREEN);
    const currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);
    const [listPatientWaiting, setListPatientWaiting] = useState<any[]>([]);
    const [listPatientCompleted, setListPatientCompleted] = useState<any[]>([]);
    const [callingPatient, setCallingPatient] = useState<any>(null);

    const handleGetListPendingPatient = async () => {
        try {
            let data = await getListPedingPatient(phongSelected?.code ?? "");
            if (CODE.SUCCESS === data?.code) {
                let _listPatientWaiting = data?.data?.filter((item: any) => item?.status === PENDING_STATUS.WAITING);
                let _listPatientCompleted = data?.data?.filter((item: any) => item?.status === PENDING_STATUS.COMPLETED);
                setCallingPatient(data?.data?.find((item: any) => item?.status === PENDING_STATUS.CALLING));
                setListPatientWaiting(_listPatientWaiting?.slice(0, MAX_LENGTH_LIST_PATIENT));
                setListPatientCompleted(_listPatientCompleted?.slice(0, MAX_LENGTH_LIST_PATIENT));
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const updateListPatient = setInterval(() => {
            handleGetListPendingPatient();
        }, 5000)

        const handler = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener("fullscreenchange", handler);

        return () => {
            document.removeEventListener("fullscreenchange", handler);
            clearInterval(updateListPatient);
        };
    }, []);

    const handleFullscreen = () => {
        if (isFullscreen) {
            document.exitFullscreen().catch(console.error);
        } else {
            document.documentElement.requestFullscreen().catch(console.error);
        }
    };

    return (
        <Container fluid className="text-white vh-100 px-3 overflow-hidden">
            <Row className="bg-white spaces height-6">
                <Col className="flex-center">
                    <p className='text-center fw-bold text-pri text-uppercase mb-0 fs-1'>{phongSelected?.name ?? ""}</p>
                </Col>
                <Col className="flex-center">
                    <p className='text-center fw-bold text-pri text-uppercase mb-0 fs-1'>{currentUser?.name ?? ""}</p>
                </Col>
            </Row>

            <Row className="spaces height-44 pt-4">
                <Col className='spaces px-2 height-100'>
                    <Card className="h-100 border-light">
                        <Card.Header className="bg-grey fs-1 text-danger fw-bold d-flex justify-content-center">
                            DSBN chờ khám - Đối tượng ưu tiên
                        </Card.Header>
                        <Card.Body className="bg-white">
                            <OctTable
                                data={[]}
                                columns={columns}
                                fixedColumnsCount={-1}
                                height={400}
                                className="h-100 table-background-th mt-n6"
                                noPagination
                                noToolbar
                            />
                        </Card.Body>
                    </Card>
                </Col>
                <Col className='spaces px-2 height-100'>
                    <Card className="h-100 border-light">
                        <Card.Header className="bg-grey fs-1 text-success fw-bold d-flex justify-content-center">
                            Đang gọi bệnh nhân
                        </Card.Header>
                        <Card.Body className="bg-white flex-center flex-column">
                            <p className='heading-1 text-dark fw-bold'>{callingPatient?.patientName ?? ""}</p>
                            <p className='heading-2 text-dark fw-bold'>{callingPatient ? `(${callingPatient?.patientCode})` : ""}</p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="spaces height-45 pt-4">
                <Col className='spaces px-2 height-100'>
                    <Card className="h-100 border-light">
                        <Card.Header className="bg-grey fs-1 text-warning fw-bold d-flex justify-content-center">
                            Danh Sách Chờ Khám
                        </Card.Header>
                        <Card.Body className="bg-white">
                            <OctTable
                                data={listPatientWaiting ?? []}
                                columns={columns}
                                fixedColumnsCount={-1}
                                className="h-100 table-background-th mt-n6"
                                noPagination
                                noToolbar
                            />
                        </Card.Body>
                    </Card>
                </Col>
                <Col className='spaces px-2 height-100'>
                    <Card className="h-100 border-light">
                        <Card.Header className="bg-grey fs-1 text-warning fw-bold d-flex justify-content-center">
                            Danh Sách Đã Có Kết Quả CLS
                        </Card.Header>
                        <Card.Body className="bg-white">
                            <OctTable
                                data={listPatientCompleted ?? []}
                                columns={columns}
                                fixedColumnsCount={-1}
                                className="h-100 table-background-th mt-n6"
                                noPagination
                                noToolbar
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="spaces height-5 pt-4 position-relative">
                <Col className="spaces py-10 fs-3 text-pri text-center bg-white">
                    Đối tượng ưu tiên: CT: Người từ đủ 75 tuổi trở lên; TH: Phụ nữ có thai; KH: Khác; CU: Cấp cứu; TE: Trẻ em dưới 6 tuổi; KT: Người khuyết tật; CC: Người có công với cách mạng
                    <CustomIconButton
                        variant="edit"
                        className="spaces position-absolute right-5 top-0 height-100 d-flex align-items-center W-50"
                        onClick={handleFullscreen}
                        title={`${isFullscreen ? "Thoát toàn màn hình" : "Toàn màn hình"}`}
                        tooltipPlacement='top'
                    >
                        <i className={`${isFullscreen ? "bi bi-fullscreen-exit" : "bi bi-fullscreen"} d-inline-block`}></i>
                    </CustomIconButton>
                </Col>

            </Row>
        </Container>
    )
}

export default PendingScreen